var render = function render(){var _vm=this,_c=_vm._self._c;return _c('callout',{staticClass:"callout",attrs:{"iconPath":"end-of-year/gift.svg","title":"ציפור לילה, מגיעה לך הטבה"},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('div',{staticClass:"ri-label"},[_vm._v("\n      ברכישת תוכנית ייעוץ אישית עד 9:00 בבוקר (ביום ו׳ 16.2), ניתן לך חודש אחד במינוי במתנה.\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }